var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"publicBtn",class:{
			'btn--confirm': _vm.type==='1',
			'btn--cancal': _vm.type==='2',
			'btn--dashed': _vm.type==='3',
			'btn--operation': _vm.type==='4',
		},style:({width:_vm.width}),attrs:{"size":_vm.size,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click','')}}},[(_vm.icon)?_c('img',{staticClass:"iconImg",attrs:{"src":_vm.icon,"alt":""}}):_vm._e(),_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3283d786","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/accBtn/index.vue
// module id = null
// module chunks = 